import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filenameFromUrl',
  standalone: true,
  pure: true
})
export class FilenameFromUrlPipe implements PipeTransform {

  transform(url: string): string {
    if (!url) {return 'File';}
    try {
      const pathname = new URL(url).pathname;
      const segments = pathname.split('/').filter(Boolean);
      const lastSegment = segments.pop() || 'File';
      const decoded = decodeURIComponent(lastSegment);
      if (/^\d+$/.test(decoded)) {return 'Photo';}
      const nameWithoutExt = decoded.replace(/\.[^.]+$/, '');
      if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(nameWithoutExt)) {
        const prevSegment = segments.length > 0 ? decodeURIComponent(segments[segments.length - 1]) : '';
        const prevWithoutExt = prevSegment.replace(/\.[^.]+$/, '');
        if (prevSegment && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(prevWithoutExt) && !/^\d+$/.test(prevSegment) && !/^(message-thread-file|attachments|files|uploads)$/i.test(prevSegment)) {
          return prevSegment;
        }
        const ext = decoded.includes('.') ? decoded.split('.').pop()?.toUpperCase() : '';
        if (ext) {return `${ext} File`;}
        return 'File';
      }
      return decoded;
    } catch {
      return 'File';
    }
  }
}
